import { createContext } from "react";

import { noop } from "lodash";

import { DEFAULT_RECYCLING_TARGET, ViewType } from "./constants";
import { ChartType } from "./types";

export type IRecyclingRateTrendContext = {
  chartType: ChartType;
  setChartType: (value: ChartType) => void;
  target: number;
  updateTarget: (value: number) => void;
  showTarget: boolean;
  setShowTarget: (value: boolean) => void;
  showCompareYear: boolean;
  setShowCompareYear: (value: boolean) => void;
  showPortfolioAverage: boolean;
  setShowPortfolioAverage: (value: boolean) => void;
  viewType: ViewType;
};

export const RecyclingRateTrendContext = createContext({
  chartType: ChartType.LINE,
  setChartType: noop,
  target: DEFAULT_RECYCLING_TARGET,
  showTarget: true,
  updateTarget: noop,
  setShowTarget: noop,
  showCompareYear: false,
  setShowCompareYear: noop,
  showPortfolioAverage: false,
  setShowPortfolioAverage: noop,
  viewType: ViewType.BUILDING,
} as IRecyclingRateTrendContext);
